import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TopBar } from './src/components/TopBar';
import { HeroSection } from './src/components/HeroSection';
import { MultiStepForm } from './src/components/MultiStepForm';
import { LegalFooter } from './src/components/LegalFooter';
import { ThankYouPage } from './src/pages/ThankYouPage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if (window.fbq && (window.fbq as any).loaded) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s);
  } else {
    document.head.appendChild(t);
  }
  window.fbq('init', '931066692924526');
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    document.title = 'The Founders Law';
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<div className="min-h-screen bg-navy flex flex-col relative" data-id="element-3">
              <TopBar data-id="element-4" />
              <main className="flex-1" data-id="element-5">
                <HeroSection data-id="element-6" />
                <MultiStepForm data-id="element-7" />
              </main>
              <LegalFooter data-id="element-8" />
            </div>} data-id="element-2" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-10" />} data-id="element-9" />
      </Routes>
      <noscript data-id="element-11">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=931066692924526&ev=PageView&noscript=1" alt="" data-id="element-12" />
      </noscript>
    </BrowserRouter>;
}